import { ICellRendererParams } from "ag-grid-community";
import dayjs from "dayjs";

export function SecondsToDateTimeRenderer(params: ICellRendererParams): string
{
	let formattedString: string;
	const seconds: number = params.value;
	const timeFormat: string = "MMM DD, h:mm:ss a";
	if (timeFormat)
	{
		formattedString = dayjs.unix(seconds).format(timeFormat);
	}
	else
	{
		formattedString = dayjs.unix(seconds).format("MMM DD, h:mm:ss a");
	}
	return formattedString;
}
